// react library imports
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { motion } from 'framer-motion';
import packageJson from '../../../package.json';

// style and assets imports
import './Sidebar.css';
import './ActiveSidebar.css';

// import local component
import Navigation from './Navigation';
import { WalletCard, UpgradeToPro, Header,
Footer } from './Component';

// redux store imports
import { getPreschoolInformation } from '../../Redux/preschool/preschool';

// define variant for the sidebar
const sidebarVariant ={
	open:{
		width:"84px",
		transition: {
			duration: 0.3,
			ease: "easeInOut",
		  },
	},
	close:{
		width: "260px",
		transition: {
			duration: 0.3,
			ease: "easeInOut",
		  },
	}
}

const Sidebar = () => {
	// get data from redux store
	const preschoolInformation = useSelector(getPreschoolInformation)
	const version = packageJson.version;

	// useState for active sidebar
	const [active, setActive]=useState(false)
  return (
	<div className={active ? "active_side_bar":""}>
		<motion.div className={`side_bar_container ${active && "active_side_bar_container"}`}
		initial="close" animate={active ? "open":"close"}
		whileHover={active && "close"}
		variants={sidebarVariant}>
			<Header preschoolInformation={preschoolInformation}
			setActive={setActive} active={active}/>
			<Navigation/>
			<WalletCard preschoolInformation={preschoolInformation}/>
			<UpgradeToPro/>
			<Footer/>
			<p className='mues_grey_I version_lap'>mues-tech version {version}</p>
		</motion.div>
	</div>
  )
}

export default Sidebar